import {
  Paper,
  Typography,
  Stack,
  Button,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import { Control } from "react-hook-form";
import dayjs from "dayjs";
import InputDate from "@/components/form/InputDate";
import InputText from "@/components/form/InputText";

interface ManualInputFormProps {
  control: Control<any>;
  inputKey: number;
  newExamsLength: number;
  onAdd: () => Promise<void>;
  isSubmitting: boolean;
  isDialogOpen: boolean;
  dateNewAnalyte: dayjs.Dayjs;
  setDateNewAnalyte: (date: dayjs.Dayjs) => void;
}

export const ManualInputForm = ({
  control,
  inputKey,
  newExamsLength,
  onAdd,
  isSubmitting,
  isDialogOpen,
  dateNewAnalyte,
  setDateNewAnalyte,
}: ManualInputFormProps) => {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 2,
        flex: 1,
      }}
    >
      <Typography
        variant="h6"
        gutterBottom
        sx={{ color: "primary.main", mb: 2 }}
      >
        Resultados de Exames
      </Typography>
      {isDialogOpen ? (
        <Stack spacing={2}>
          <Skeleton variant="rectangular" height={56} />
          <Stack direction="row" spacing={2}>
            <Skeleton variant="rectangular" height={56} sx={{ flexGrow: 1 }} />
            <Skeleton variant="rectangular" height={56} width={120} />
          </Stack>
          <Skeleton variant="rectangular" height={56} />
          <Skeleton variant="rectangular" height={36} />
        </Stack>
      ) : (
        <Stack spacing={2}>
          <InputDate
            key={`date-${inputKey}`}
            label="Data de Referência"
            name={`newExames.${newExamsLength}.date`}
            control={control}
            defaultValue={dateNewAnalyte}
            handleChange={(e: any) => setDateNewAnalyte(dayjs(e))}
          />
          <InputText
            key={`name-${inputKey}`}
            label="Nome do Analito"
            name={`newExames.${newExamsLength}.name`}
            control={control}
            fullWidth
          />
          <Stack direction="row" spacing={2}>
            <InputText
              key={`value-${inputKey}`}
              label="Valor"
              name={`newExames.${newExamsLength}.value`}
              control={control}
              sx={{ flexGrow: 1 }}
            />
            <InputText
              key={`unit-${inputKey}`}
              label="Unidade"
              name={`newExames.${newExamsLength}.unit`}
              control={control}
              sx={{ width: 120 }}
            />
          </Stack>

          <Button
            variant="contained"
            onClick={onAdd}
            fullWidth
            disabled={isSubmitting}
            startIcon={
              isSubmitting ? (
                <CircularProgress size={20} color="inherit" />
              ) : null
            }
          >
            {isSubmitting ? "Adicionando..." : "Adicionar"}
          </Button>
        </Stack>
      )}
    </Paper>
  );
};
